import {Amount} from "app/model/amount";
import {DeliveryMethod} from "app/model/deliveryMethod";
import {camelCase} from 'lodash';

export const currencyMapper = (currencyPairs, currenciesIn) => {
    const currencies = {};
    currenciesIn.forEach((currency) => {
        currencies[currency] = currencyPairs
            .map((item) => {
                if (item.currency_in.name === currency) {
                    return item.currency_out.name;
                }
            })
            .filter(Boolean);
    });

    return currencies;
};

export const deliveryMethodsFeeMapper = (methods, currency) => {
    const result = {};

    methods.forEach((method) => {
        const fees = method.fee;
        method.fee = {};

        fees.forEach((fee) => {
            method.fee[camelCase(fee.type)] = Amount.createMoney(fee.value.amount, currency);
        });

        result[method.name] = DeliveryMethod.create(method);
    });

    return result;
};
